import { getAuthGroups } from '../../../utils/auth';
import { MAX_SEARCH_RESULTS_PER_CATEGORY } from '../constants';

export function dedupeBy(items, getKey) {
  const seen = new Set();
  return items.filter((item) => {
    const key = getKey(item);
    if (!key || seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
}

export function limitItems(items, limit = MAX_SEARCH_RESULTS_PER_CATEGORY) {
  return Array.isArray(items) ? items.slice(0, limit) : [];
}

export async function getMerchantNames(organizationName) {
  if (organizationName) {
    return [organizationName];
  }

  const groups = await getAuthGroups();
  return Array.isArray(groups) ? groups.filter(Boolean) : [];
}

export function createToolMessageId() {
  return typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? `tool-${crypto.randomUUID()}`
    : `tool-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

function normalizeComparableValue(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

export function getContactMatchScore(contact, query) {
  const normalizedQuery = normalizeComparableValue(query);
  const normalizedName = normalizeComparableValue(contact.name);
  const normalizedEmail = normalizeComparableValue(contact.email);

  if (!normalizedQuery) {
    return 0;
  }
  if (normalizedEmail && normalizedEmail === normalizedQuery) {
    return 100;
  }
  if (normalizedName && normalizedName === normalizedQuery) {
    return 95;
  }
  if (normalizedEmail && normalizedEmail.includes(normalizedQuery)) {
    return 80;
  }
  if (normalizedName && normalizedName.includes(normalizedQuery)) {
    return 70;
  }
  return 0;
}
